import isEqual from 'lodash.isequal'
import { createSelectorCreator, defaultMemoize } from 'reselect'

const createSelector = createSelectorCreator(defaultMemoize, { equalityCheck: isEqual, maxSize: 20 })

export const selectCitationsBillions = createSelector(
  state => state.stats,
  (stats) => Math.floor(
    ((stats?.citationsTotal || CONFIG.defaultCitationsTotal) / 100000000)
  ) / 10
)

export const selectDistinctSourcesMillions = createSelector(
  state => state.stats,
  (stats) => Math.floor(stats?.citationsDistinctSources / 1000000) || CONFIG.defaultSourcesTotal
)

export const selectTraditionalCitationsBillions = createSelector(
  state => state.stats,
  (stats) => Math.floor(
    ((stats?.uniqueCitations || CONFIG.defaultTraditionalCitationsTotal) / 100000000)
  ) / 10
)

export const selectPapersMillions = createSelector(
  state => state.stats,
  (stats) => Math.floor(stats?.papersTotal / 1000000) || CONFIG.defaultPapersTotal
)
